import { render } from "./Models.vue?vue&type=template&id=89d4fe18&scoped=true"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"

import "./Models.vue?vue&type=style&index=0&id=89d4fe18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-89d4fe18"

export default script